<template>
  <section class="section youtube-video">
    <iframe
      :src="`${videoLink}?controls=0&rel=0&modestbranding=1&showinfo=0`"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
      :loading=loading
    ></iframe>
  </section>
</template>
<script setup lang="ts">

defineProps<{
  videoLink: string
  loading: string
}>();
</script>
